import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withHandlers,
  lifecycle,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ReactSelectMaterialUi from 'react-select-material-ui';
import GochiMenuDetailTable from '../../components/molecules/GochiMenuDetailTable';
import CloseButton from '../../components/atoms/CloseButton';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({ classes, detail, updateOpenDetailModal, isLanguage, setIsLanguage }) => {
    let { menuName, quantityFreeDes, description } = detail;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = detail.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData) {
        ({ menuName, description, quantityFreeDes } = languageData.params);
      }
    }
    const closeAction = () => updateOpenDetailModal(false);
    return (
      <div className={classes.root}>
        <Typography variant="h6">メニュー情報詳細</Typography>
        <div>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
          <GochiMenuDetailTable
            menuName={menuName}
            price={detail.price}
            taxTypeStr={detail.taxTypeStr}
            reducedTaxTypeStr={detail.reducedTaxTypeStr}
            description={description}
            tags={detail.tags}
            comboMenu={detail.menuCombo}
            priceCombo={detail.priceCombo}
            quantityRelease={detail.quantity}
            quantityPromotion={detail.quantityFree}
            promotionDescription={quantityFreeDes}
            usageLimit={detail.numberUsePerDay}
            expiration={detail.expiration}
            expirationEndDate={detail.expirationEndDate}
            image={detail.image}
            subscription={detail.subscription}
            subscriptionIntervalCount={detail.subscriptionIntervalCount}
            subscriptionInterval={detail.subscriptionInterval}
            createdAt={detail.createdAt}
            updatedAt={detail.updatedAt}
            genreName={detail.menuGenreName}
            situationNames={detail.menuSituationNames}
            userTargetNames={detail.menuUserTargetNames}
            menuLimitTotal={detail.menuLimitTotal}
            menuChildType={detail.menuChildType}
            showPrice={detail.showPrice}
            usageType={detail.usageType}
          />
        </div>
        <div>
          <CloseButton onClickAction={closeAction} />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
